import { render, staticRenderFns } from "./AnexoConsultoria.vue?vue&type=template&id=318706c6&scoped=true&"
import script from "./AnexoConsultoria.vue?vue&type=script&lang=js&"
export * from "./AnexoConsultoria.vue?vue&type=script&lang=js&"
import style0 from "./AnexoConsultoria.vue?vue&type=style&index=0&id=318706c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318706c6",
  null
  
)

export default component.exports